import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import {
  CREATERANK,
  GETALLLISTUSERS,
  GETALLRANKUSERS,
  GETRANKSLITE,
  REMOVERANK,
  REMOVERANKFROMUSER,
} from '../endpoints';

export const createRank = async (rankName: string) => {
  const response = await client.post(`${baseUrl}${CREATERANK}`, { rankName });
  return response;
};

export const updateRank = async (rankId: number, rankName: string) => {
  const response = await client.put(`${baseUrl}/ranks/${rankId}`, {
    rankName,
    rankId,
  });
  return response;
};

export const getAllRanks = async ({
  page,
  size,
  q,
}: {
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(`${baseUrl}${GETALLRANKUSERS}`, {
    params: {
      page,
      size,
      q,
    },
  });
  return response;
};

export const getUsersByRankId = async ({
  rankId,
  page,
  size,
  q,
}: {
  rankId: number;
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(`${baseUrl}${GETALLRANKUSERS}/${rankId}`, {
    params: {
      page,
      size,
      q,
    },
  });
  return response;
};

export const removeRankFromUser = async (userId: number) => {
  const response = await client.delete(
    `${baseUrl}${REMOVERANKFROMUSER}/${userId}`
  );
  return response;
};

export const removeRank = async (rankId: number) => {
  const response = await client.delete(`${baseUrl}${REMOVERANK}/${rankId}`);
  return response;
};

export const getListUserDetails = async () => {
  const response = await client.get(`${baseUrl}${GETALLLISTUSERS}`);
  return response;
};

export const getAllLiteRanks = async () => {
  const response = await client.get(`${baseUrl}${GETRANKSLITE}`);
  return response;
};
